// Les icônes maison, côté React.
//
// `js/icones.js` rend du HTML sous forme de chaîne, ce qui convenait au monde
// d'avant. Ici on l'enveloppe une bonne fois : le composant reste le seul
// endroit de l'application React où l'on injecte du HTML brut, et il n'injecte
// que nos propres tracés — jamais rien qui vienne d'un membre.

import { icone } from "../icones.js";

export default function Icone({ nom, taille = 20, plein = false, classe = "" }) {
  const html = icone(nom, { taille, plein, classe });
  if (!html) return null;
  return <span className="icone-hote" dangerouslySetInnerHTML={{ __html: html }} />;
}

/**
 * La paire contour + plein, dont le CSS montre l'une ou l'autre selon
 * `.est-actif`. C'est ce qui donne l'effet « icône qui se remplit » — la barre
 * de navigation et l'Amen s'en servent.
 */
export function IconeDuo({ nom, taille = 24 }) {
  // Les deux tracés sont posés DIRECTEMENT dans `.icone-duo` : le CSS les
  // superpose avec `.icone-duo > .icone`, un sélecteur d'enfant direct. Passer
  // par le composant Icone ajouterait un `.icone-hote` entre les deux et
  // l'empilement ne tiendrait plus — les deux icônes s'afficheraient l'une
  // sous l'autre.
  const html =
    icone(nom, { taille, classe: "icone--trait" }) +
    icone(nom, { taille, plein: true, classe: "icone--plein" });
  return <span className="icone-duo" dangerouslySetInnerHTML={{ __html: html }} />;
}
